import React from 'react';
import { IconHighlight, Typography } from '@ann/web-components';
import { Container, IconContainer, TitleContainer, SubtitleContainer } from './EmptyAgentState.styled';

const EmptyAgentState = () => {
  return (
    <Container>
      <IconContainer>
        <IconHighlight
          bgColor="Primary"
          icon="star"
          iconColor="PrimaryLighter"
          size="medium"
        />
      </IconContainer>
      <TitleContainer>
        <Typography category="title" size="large" weight="bold">
          Pick an agent to get started
        </Typography>
      </TitleContainer>
      <SubtitleContainer>
        <Typography category="body" size="medium" weight="regular">
          Agents specialize in different roles. Select one and we'll take it from there.
        </Typography>
      </SubtitleContainer>
    </Container>
  );
};

export default EmptyAgentState;

